import React, { useEffect, useState, useCallback, useRef, memo } from "react";
import { Input, Button, Spinner } from "reactstrap";
import {
  DragDropContext,
  Draggable,
  DraggingStyle,
  Droppable,
  DropResult,
  NotDraggingStyle,
} from "@hello-pangea/dnd";
import { GridStack } from "gridstack";
import "gridstack/dist/gridstack.min.css";

import setting from "../../../assets/images/icons/console-6.svg";
import lightSetting from "../../../assets/images/icons/console-6.svg";

import widgetGroupMaker from "../../../assets/images/icons-component/group.png";

import { screenState } from "../../../store/screen/slice";
import { useAppSelector } from "../../../store/hooks";

import CustomDraggingStyle from "./CustomDraggingStyle";

const Index = (props: any) => {
  const { username } = useAppSelector(state => screenState(state));
  const {
    config,
    insideRef,
    insideSwitch,
    openOption,
    onUpdate,
    actionEnd,
    inside,
  } = props;
  const [MemberList, setMemberList] = useState<string[]>([]);
  const [Groups, setGroups] = useState<string[][]>([]);
  const [onCreate, setOnCreate] = useState<boolean>(false);

  const gridRefs = useRef<any>([]);

  useEffect(() => {
    if (config.data && config.data.nameList) {
      getNameList();
    }
  }, [config.data?.nameList]);

  useEffect(() => {
    if (config.data && config.data.groupList) {
      setGroups(config.data.groupList);
    }
  }, [config.data?.groupList]);

  useEffect(() => {
    if (!isDoubleArrayEmpty(Groups)) {
      const data = config.data;
      data.groupList = Groups;
      onUpdate({
        id: config.id,
        data: { ...data },
      });
      actionEnd(true);
    }
  }, [Groups]);

  useEffect(() => {
    if (MemberList.length !== 0 && config.data?.groupList.length === 0) {
      const itemGroup = splitArrayIntoGroups(Groups, config.data.groups);
      setGroups(itemGroup);
    }
  }, [MemberList, config.data?.groupList]);

  const isDoubleArrayEmpty = (arr: any) => {
    if (!Array.isArray(arr)) {
      return false;
    }
    if (arr.length === 0) {
      return true;
    }
    for (const element of arr) {
      if (!Array.isArray(element) || !isDoubleArrayEmpty(element)) {
        return false;
      }
    }
    return true;
  };

  const shuffleArray = (array: any[]) => {
    for (let i = array.length - 1; i > 0; i--) {
      const j = Math.floor(Math.random() * (i + 1));
      [array[i], array[j]] = [array[j], array[i]];
    }
  };

  const splitArrayIntoGroups = (array: any[], groups: number): any[][] => {
    const shuffledArray = [...array];
    shuffleArray(shuffledArray);

    const result: any[][] = new Array(groups).fill(null).map(() => []);
    let groupIndex = 0;

    for (const item of shuffledArray) {
      result[groupIndex].push(item);
      groupIndex = (groupIndex + 1) % groups;
    }

    return result;
  };

  const processDuplicates = (array: string[]): string[] => {
    const countMap: { [key: string]: number } = {};
    const result: string[] = [];

    for (const str of array) {
      if (countMap[str] === undefined) {
        countMap[str] = 1;
        result.push(str);
      } else {
        const count = countMap[str];
        countMap[str]++;
        result.push(`${str}(${count})`);
      }
    }

    return result;
  };

  const randomMember = () => {
    if (MemberList.length !== 0) {
      const itemGroup = splitArrayIntoGroups(MemberList, config.data.groups);
      setGroups(itemGroup);
      if (!onCreate) {
        setOnCreate(true);
      }
    }
  };

  const getNameList = () => {
    const setArr = [...config.data.nameList].map(item =>
      item.length > 40 ? item.slice(1, 40) : item,
    );
    const processedArray = processDuplicates(setArr);
    setMemberList(processedArray);
  };

  const [ElementStyle, setElementStyle] = useState({});
  const [placeholderProps, setPlaceholderProps] = useState({});

  const queryAttr = "data-rfd-drag-handle-draggable-id";
  const getDraggedDom = (draggableId: any) => {
    const domQuery = `[${queryAttr}='${draggableId}']`;
    const draggedDOM = document.querySelector(domQuery);
    return draggedDOM;
  };

  const onDragEnd = (result: DropResult): void => {
    if (!result.destination) {
      return;
    }

    const sourceListIndex = Number(result.source.droppableId);
    const destListIndex = Number(result.destination.droppableId);

    if (sourceListIndex === destListIndex) {
      const updatedGroup = [...Groups];
      const items = updatedGroup[sourceListIndex];
      const [removed] = items.splice(result.source.index, 1);
      items.splice(result.destination.index, 0, removed);
      setGroups(updatedGroup);
    } else {
      const updatedGroup = [...Groups];
      const sourceItems = updatedGroup[sourceListIndex];
      const destItems = updatedGroup[destListIndex];
      const [movedItem] = sourceItems.splice(result.source.index, 1);
      destItems.splice(result.destination.index, 0, movedItem);
      setGroups(updatedGroup);
    }

    setElementStyle({});
  };

  useEffect(() => {
    gridRefs.current.forEach((ref: any, index: any) => {
      if (ref) {
        const grid = GridStack.init(
          {
            float: false,
            cellHeight: 40,
            column: 12,
            minRow: 1,
            draggable: {
              handle: ".grid-stack-item-content",
            },
          },
          ref,
        );
        const gridItems = ref.querySelectorAll(".grid-stack-item");
        gridItems.forEach((item: any, i: any) => {
          grid.update(item, { x: 0, y: i, width: 12, height: 2 } as any);
        });
      }
    });
  });

  return (
    <React.Fragment>
      <div style={{ height: "100%", width: "100%", position: "absolute" }}>
        {config.data && config.data.nameList.length > 0 ? (
          <div
            className="componentCore  overflow-hidden"
            style={{ height: "100%", width: "100%" }}
          >
            <React.Fragment>
              <div className="group-items">
                <DragDropContext onDragEnd={onDragEnd}>
                  {(Groups || []).map((list: any, listIndex: number) => (
                    <Droppable
                      droppableId={listIndex.toString()}
                      key={listIndex}
                    >
                      {(provided, snapshot): JSX.Element => (
                        <div
                          className="group-item"
                          key={listIndex}
                          {...provided.droppableProps}
                          ref={provided.innerRef}
                        >
                          <div className="g-header">
                            <div className="p-1">
                              <div className="ml-3 mb-0 cursor-text overflow-hidden truncate !text-white crs-title h-10 pt-[7px] !text-xl">
                                Group {listIndex + 1}
                              </div>
                            </div>
                          </div>
                          <div className="flex flex-col py-1">
                            {list.map((item: any, index: number) => (
                              <Draggable
                                key={`item-${listIndex}-${index}`}
                                draggableId={`item-${listIndex}-${index}`}
                                index={index}
                              >
                                {(provided, snapshot) => (
                                  <CustomDraggingStyle
                                    dragProps={provided}
                                    snapshot={snapshot}
                                  >
                                    <div className="group flex flex-row items-center gap-2 p-2">
                                      <span className="flex-1 font-semibold text-xl -mt-0.5">
                                        {item}
                                      </span>
                                    </div>
                                  </CustomDraggingStyle>

                                  // <div
                                  //   ref={provided.innerRef}
                                  //   {...provided.draggableProps}
                                  //   {...provided.dragHandleProps}
                                  //   className="student-item"
                                  //   data-interaction-ignore-drag="true"
                                  //   data-interaction-target-type="false"
                                  // >
                                  //   <div className="group flex flex-row items-center gap-2 p-2">
                                  //     <span className="flex-1 font-semibold text-xl -mt-0.5">{item}</span>
                                  //   </div>
                                  // </div>
                                )}
                              </Draggable>
                            ))}
                          </div>
                          {provided.placeholder}
                        </div>
                      )}
                    </Droppable>
                  ))}
                </DragDropContext>
              </div>
              <div
                className="absolute bottom-0 left-0 mb-4 flex flex-row justify-center"
                style={{ width: "100%" }}
              >
                {!onCreate ? (
                  <Button
                    color="primary"
                    className="core-btn ts-playBtn btn-load rounded-pill text-sm px-4 h-11 font-semibold"
                    onPointerDown={() => randomMember()}
                    data-interaction-target-type="false"
                  >
                    <div className="relative justify-center h-100 w-100">
                      <span>進行分組</span>
                    </div>
                  </Button>
                ) : (
                  <Button
                    color="primary"
                    className="core-btn ts-playBtn btn-load rounded-pill text-sm px-4 h-11 font-semibold"
                    onPointerDown={() => randomMember()}
                    data-interaction-target-type="false"
                  >
                    <div className="relative justify-center h-100 w-100">
                      <span>重新分組</span>
                    </div>
                  </Button>
                )}
              </div>
            </React.Fragment>
          </div>
        ) : (
          <div
            className="absolute top-0 start-0 origin-left-top"
            style={{ ...inside }}
          >
            <div
              style={{ height: "100%", width: "100%", position: "absolute" }}
            >
              <div
                className="relative flex h-full flex-col items-center justify-center p-6 bg-screen  overflow-hidden"
                style={{ cursor: "auto" }}
              >
                <div className="widget-head">
                  <img
                    className="widget-img-icon"
                    src={widgetGroupMaker}
                    alt=""
                  />
                </div>
                <p className="text-dark-500 mb-6 px-4 text-center text-xl font-semibold transition-[color]">
                  分組
                </p>
                <Button
                  color="light"
                  className={`ts-playBtn settingBtn btn-load rounded-pill text-sm px-4 h-12 font-semibold`}
                  onClick={(e: any) => {
                    openOption();
                  }}
                  data-interaction-target-type="false"
                >
                  <div className="relative justify-center h-100 w-100">
                    <span className="flex items-center justify-center w-100">
                      設定
                    </span>
                  </div>
                </Button>
              </div>
            </div>
          </div>
        )}
      </div>
      {username ? (
        <div
          className="absolute h-100 w-100 top-0 start-0"
          style={{ zIndex: 2 }}
        ></div>
      ) : null}
    </React.Fragment>
  );
};

export default memo(Index);
